export default __webpack_public_path__ + "static/media/Akustikdecken.7052130e.jpg";